import { render } from "./ViewDocument.vue?vue&type=template&id=e96d1396&scoped=true"
import script from "./ViewDocument.vue?vue&type=script&lang=js"
export * from "./ViewDocument.vue?vue&type=script&lang=js"

import "./ViewDocument.vue?vue&type=style&index=0&id=e96d1396&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e96d1396"]])

export default __exports__